export default {
    SET_TIME_CHANGES(state, timeChanges) {
        state.timeChanges = timeChanges
    },
    SET_REASON_CHANGES(state, reasonChanges) {
        state.reasonChanges = reasonChanges
    },
    SET_CHANGES(state, changes) {
        state.divisionTimeChanges = changes
    },
    ADD_DIVISION_TIME_CHANGES(state, divisionTimeChanges) {
        if (!state.divisionTimeChanges) {
            state.divisionTimeChanges = []
        }
        if (divisionTimeChanges) {
            divisionTimeChanges.forEach(e => {
                const time =
                    e.old.cooking_time !== undefined
                        ? 'cooking_time'
                        : 'delivery_time'
                state.divisionTimeChanges.push({
                    id: e.id,
                    author: e.user?.fio,
                    role: e.user?.roles?.join(', '),
                    dateTime: e.created_date,
                    typeTime:
                        time === 'cooking_time'
                            ? 'Время готовки'
                            : 'Время доставки',
                    oldValue: e.old[time],
                    newValue: e.new[time],
                    reason: e.reason,
                    comment: e.comment,
                    sector: e.sector_name,
                })
            })
        }
    },
}
